import {Component, EventEmitter, Injector, Input, Output} from '@angular/core';
import {ContactUsComponent} from "../../layout/legal/contact-us/contact-us.component";
import {MatDialog} from "@angular/material/dialog";
import {ScreenNamesEnum} from "../../model/enum/screen-names-enum";
import {ToastrService} from "ngx-toastr";
import {OverlayUtils} from "../../utils/overlay-utils";
import {ConfirmationDialogComponent} from "../../shared/confirmation-dialog/confirmation-dialog.component";
import {NotificationWindowDetails} from "../../pro-report/shared/notification-window";
import {ProReportConstants} from "../../pro-report/shared/pro-report-constants";
import {Notification_Window_TOKEN} from "../../pro-report/shared/injection-token";
import {ObligorSearchTable} from "../obligor-search-table";
import {ChangePasswordComponent} from "../change-password/change-password.component";
import {Router} from "@angular/router";
import {TransitionTypesEnum} from "../../model/enum/transition-types-enum";

@Component({
  selector: 'app-portal-header',
  templateUrl: './portal-header.component.html',
  styleUrls: ['./portal-header.component.scss']
})
export class PortalHeaderComponent {

  @Input()
  public displayRightMenu = true;

  @Input()
  public displayRightLogo = false;

  @Input()
  public displaySearchIcon = false;

  @Input()
  public displayCalendarIcon = true;

  @Input()
  public dirtyFlag = false;

  @Output()
  public screenToShow = new EventEmitter<ScreenNamesEnum>();

  @Output()
  public openSearchPanel = new EventEmitter<void>();

  constructor(private dialog: MatDialog,
              private router: Router,
              private toastr: ToastrService,
              private overlayUtils: OverlayUtils,
              private obligorSearchTable: ObligorSearchTable) {

  }

  handleMiddleClick(event: MouseEvent) {
    if (event.button === 1) {
      window.open('/', '_blank');
    }
  }

  backToMainPage() {
    if (this.dirtyFlag) {
      const nwd = new NotificationWindowDetails();
      nwd.text = ProReportConstants.backToMainWarning;
      nwd.header = ProReportConstants.backToMainHeader;
      nwd.headerClass = 'font-size-245'
      nwd.buttonsReverse = true;
      const warningWindow = this.overlayUtils.createOverLay(ConfirmationDialogComponent, Injector.create({
        providers: [{provide: Notification_Window_TOKEN, useValue: nwd}]
      }), null);
      warningWindow.closeObs$.subscribe({
        next: (res: boolean) => {
          if (res === true) {
            this.navigate();
          }
        }
      });
    } else {
      this.navigate();
    }
  }

  private navigate(): void {
    this.router.navigateByUrl('/', {
      state: {
        'transitionType': TransitionTypesEnum.FORWARD_CALENDAR,
        'recentSearch': ''
      }
    });
    this.screenToShow.emit(ScreenNamesEnum.forwardCalendar);
  }

  public openContactUs(): void {
    this.dialog.open(ContactUsComponent, {
      height: '450px',
      width: '560px'
    });
  }

  openChangePasswordPopup() {
    this.overlayUtils.createOverLay(ChangePasswordComponent, null, null)
  }

  openSearchPanelClick() {
    this.openSearchPanel.emit();
  }
}
